/**
 * Détecte de façon FIABLE si on tourne dans l'APK Android (n'importe quel
 * flavor — téléphone standard OU TV portrait), pas seulement en navigateur
 * web classique.
 *
 * `window.AndroidAudio` est le pont JS le plus ancien et le plus basique —
 * injecté INCONDITIONNELLEMENT pour TOUS les flavors dans MainActivity.kt
 * (contrairement à `window.__blcAndroid` ou la classe CSS `tv`, qui ne sont
 * posés que côté APK TV portrait forcé — donc toujours faux sur le téléphone
 * standard, ce qui cassait silencieusement toute logique qui s'y fiait).
 */
export function isNativeApp(): boolean {
  return typeof window !== 'undefined' && !!(window as any).AndroidAudio
}
